<template>
  <div class="info-section">
    <div class="section-header" @click="toggleSection">
      <i
        :class="[
          'mdi',
          isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right',
        ]"
      ></i>
      <span>Детальна інформація</span>
    </div>
    <div v-if="isExpanded" class="section-content">
      <div class="info-row">
        <label>Тікет</label>
        <p>#{{ ticket.ticketId }}</p>
      </div>
      <div class="info-row">
        <label>Тип тікету</label>
        <p>{{ ticket.type }}</p>
      </div>
      <div class="info-row">
        <label>Проєкт</label>
        <p>{{ ticket.problemEnvironment || "-" }}</p>
      </div>
      <div class="info-row">
        <label>Статус рішення</label>
        <p>{{ ticket.decidedStatus || "-" }}</p>
      </div>
      <div class="info-row">
        <label>Статус</label>
        <p>{{ ticket.status }}</p>
      </div>
      <div class="info-row">
        <label>Пріоритет</label>
        <p>{{ ticket.priority }}</p>
      </div>
      <div class="info-row">
        <label>Створив</label>
        <p>{{ ticket.createWorkerId }}</p>
      </div>
      <div class="info-row">
        <label>Дата створення</label>
        <p>{{ ticket.createDatetime }}</p>
      </div>
      <div class="info-row">
        <label>Взяли в роботу</label>
        <p>{{ ticket.inJobDatetime || "-" }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketInfoSection",
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["toggle"],
  data() {
    return {
      isExpanded: this.expanded,
    };
  },
  watch: {
    expanded(newVal) {
      this.isExpanded = newVal;
    },
  },
  methods: {
    toggleSection() {
      this.isExpanded = !this.isExpanded;
      this.$emit("toggle", this.isExpanded);
    },
  },
};
</script>

<style scoped>
.info-section {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  color: #495057;
}

.section-header i {
  font-size: 16px;
}

.section-content {
  padding-left: 24px;
  margin-top: 8px;
}

.info-row {
  margin-bottom: 12px;
}

.info-row label {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-row p {
  margin: 0;
  font-size: 13px;
  color: #212529;
}

@media (max-width: 768px) {
  .section-header {
    font-size: 12px;
    padding: 6px 0;
  }

  .info-row {
    margin-bottom: 10px;
  }

  .info-row label {
    font-size: 10px;
  }

  .info-row p {
    font-size: 12px;
  }
}
</style>
